import React from "react";
import ExperiencePrint from "../components/ExperiencePrint";
import "../css/print.scss";
import { INTRO, JOBS, SKILLS } from "../raw_cv.js";

class PrintApp extends React.Component {
  render() {
    return (
      <div id="page-wrap" className="print">
        <div id="contact-info" className="vcard">
          <h1 className="fn">
            <a className="contact__name" href="/">
              Alexander Chan
            </a>
          </h1>
          <p>
            <a href="mailto:achan@convergentis.com">alex@alexchan.info</a>
            {/* <i className="fa fa-twitter fa-lg" aria-hidden="true" />
            @alexandermchan */}
          </p>
        </div>

        <div className="intro">
          <p>{INTRO}</p>
        </div>

        <div className="clear" />
        <dl className="dl-horizontal">
          <dd className="clear" />
          <dt>Experience</dt>
          <dd>
            <ExperiencePrint jobs={JOBS} />
          </dd>

          <dd className="clear" />
          <dt>Education</dt>
          <dd>
            <h2>
              Queen's University <span className="job__country">- Canada</span>
            </h2>
            <p>
              <strong>
                Bachelor of Science - Electrical Engineering - 2001
              </strong>{" "}
              - Graduated with First Class Honours
              <br />{" "}
            </p>
          </dd>

          <dd className="clear" />
          <dt>Skills</dt>
          <dd>
            {SKILLS.map(skill => (
              <div key={skill.name}>
                <h2>{skill.name}</h2>
                <p>{skill.list}</p>
              </div>
            ))}
            <div>
              <a href="https://github.com/alexanderchan">
                <i className="fab fa-github" /> github.com/alexanderchan
              </a>
            </div>
          </dd>
        </dl>
        <div className="clear" />
      </div>
    );
  }
}

export default PrintApp;
